import { decode } from "base64-arraybuffer";

/**
 *  DEPRECATED - DO NOT USE Error with atob function
 * Convert base64 to ArrayBuffer
 * @param {string} base64
 * @returns {ArrayBuffer}
 * @see https://stackoverflow.com/a/21797381/6509751
 */

/**
 * Convert base64 to ArrayBuffer (using base64-arraybuffer package)
 * @param {string} base64
 * @returns  {ArrayBuffer}
 */
function base64ToArrayBuffer(base64) {
  return decode(base64);
}

export async function uploadToS3(url, image, contentType = "image/jpeg") {
  const text = image.replace(/^data:image\/\w+;base64,/, "");
  const buffer = base64ToArrayBuffer(text);
  await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": contentType,
      "Content-Encoding": "base64",
    },
    body: buffer,
  });
}

export async function uploadImageBackend({
  file,
  uploadMedia,
  setMediaPublic,
  enqueueSnackbar,
  isEvent,
}) {
  const reader = new FileReader();
  const accessToken = localStorage.getItem("accessToken");

  let url = undefined;

  reader.addEventListener(
    "load",
    async () => {
      try {
        // convert image file to base64 string
        const base64File = reader.result;

        if (base64File !== "") {
          const {
            data: {
              uploadMedia: { id, publicUrl, uploadUrl },
            },
          } = await uploadMedia({
            variables: {
              fileName: file.name,
              fileType: file.type,
              isEvent: isEvent,
            },
            context: { headers: { Authorization: accessToken } },
          });

          await uploadToS3(uploadUrl || "", base64File);

          await setMediaPublic({
            variables: { setMediaPublicId: id },
            context: { headers: { Authorization: accessToken } },
          });

          url = publicUrl;
          return publicUrl;
        }
      } catch (error) {
        console.log(error);
        enqueueSnackbar("Could not upload photo!", {
          variant: "error",
        });
      }
    },
    false
  );

  if (file) {
    await reader.readAsDataURL(file);
    return url;
  }
}
